import { render, staticRenderFns } from "./PracticeUpdate.vue?vue&type=template&id=4122d48a&"
import script from "./PracticeUpdate.vue?vue&type=script&lang=js&"
export * from "./PracticeUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PracticeUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PracticeUpdate.vue"
export default component.exports